import { FC } from 'react'
import { AtendimentoView } from '../../apps/atendimento/core/_models'
import { AtendimentoEstado, IconPaths, IconSize, KTSVG } from '../../../../_metronic/helpers'
import styles from './styles/EncerramentoTeleConsulta.module.css'

type IProps = {
  atendimento?: AtendimentoView
}

const duracaoEmMinutos = (inicio?: string, termino?: string) => {
  if (!inicio || !termino) return undefined
  const minutos = Math.round((new Date(termino).getTime() - new Date(inicio).getTime()) / 60000)
  return Number.isFinite(minutos) && minutos > 0 ? minutos : undefined
}

const iniciais = (nome: string) =>
  nome
    .split(' ')
    .filter(Boolean)
    .map((parte) => parte[0])
    .filter((_, i, partes) => i === 0 || i === partes.length - 1)
    .join('')
    .toUpperCase()

export const EncerramentoTeleConsulta: FC<IProps> = ({ atendimento }) => {
  const cancelada = atendimento?.estado?.id === AtendimentoEstado.Cancelado
  const primeiroNome = atendimento?.paciente?.nome?.split(' ')[0]
  const responsavel = atendimento?.responsavel?.nome
  const duracao = cancelada
    ? undefined
    : duracaoEmMinutos(atendimento?.inicio, atendimento?.termino)

  return (
    <div className='container d-flex flex-column justify-content-center align-items-center flex-grow-1 py-6'>
      <section
        className={`${styles.card} bg-white rounded-4 w-100`}
        aria-labelledby='encerramento-titulo'
      >
        <div className={`${styles.cabecalho} text-center px-6 pt-8 pb-10`}>
          <div className={`${styles.selo} mx-auto mb-4`} aria-hidden='true'>
            <KTSVG path={cancelada ? IconPaths.CalendarX : IconPaths.Check} size={IconSize.Large} />
          </div>
          <h1 id='encerramento-titulo' className='text-white fs-2 mb-2'>
            {cancelada ? 'Consulta cancelada' : 'Consulta finalizada'}
          </h1>
          <p className={`${styles.subtitulo} fs-6 mb-0`}>
            {cancelada
              ? `${primeiroNome ? `${primeiroNome}, sua` : 'Sua'} consulta foi cancelada.`
              : `Obrigado${
                  primeiroNome ? `, ${primeiroNome}` : ''
                }. Seu atendimento foi concluído.`}
          </p>
        </div>

        <div className='px-6 pt-6'>
          {responsavel && (
            <div className='d-flex align-items-center gap-3 pb-4 border-bottom border-gray-300'>
              <div
                className={`${styles.avatar} d-flex flex-center fw-semibold flex-shrink-0`}
                aria-hidden='true'
              >
                {iniciais(responsavel)}
              </div>
              <div>
                <p className='fw-semibold text-gray-900 fs-6 mb-0'>{responsavel}</p>
                <p className='text-gray-700 fs-7 mb-0'>
                  {atendimento?.especialidade?.nome ?? 'Profissional de saúde'}
                </p>
              </div>
            </div>
          )}

          <dl className='row g-3 py-4 mb-0 fs-7'>
            {!cancelada && atendimento?.terminoFormatado && (
              <div className='col'>
                <dt className='text-gray-700 fw-normal'>Finalizada em</dt>
                <dd className='fw-semibold text-gray-900 mb-0'>{atendimento.terminoFormatado}</dd>
              </div>
            )}
            {duracao && (
              <div className='col'>
                <dt className='text-gray-700 fw-normal'>Duração</dt>
                <dd className='fw-semibold text-gray-900 mb-0'>{duracao} min</dd>
              </div>
            )}
            {atendimento?.protocolo && (
              <div className='col'>
                <dt className='text-gray-700 fw-normal'>Protocolo</dt>
                <dd className={`${styles.numero} fw-semibold text-gray-900 mb-0`}>
                  {atendimento.protocolo}
                </dd>
              </div>
            )}
          </dl>
        </div>

        <p className='text-center text-gray-700 fs-7 border-top border-gray-300 px-6 py-4 mb-0'>
          {cancelada
            ? 'Em caso de dúvida, entre em contato com o estabelecimento.'
            : 'Você já pode fechar esta página.'}
        </p>
      </section>
    </div>
  )
}
